module.exports = __webpack_public_path__ + "static/media/mohit.53cecbd1.jpeg";